import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
const executeFinalizer = finalizer => {
  if (typeof finalizer === 'function') {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
};
var _finalizers = /*#__PURE__*/_classPrivateFieldLooseKey("finalizers");
export class Subscription {
  constructor() {
    Object.defineProperty(this, _finalizers, {
      writable: true,
      value: new Set()
    });
    this.closed = false;
  }
  add(finalizer) {
    if (this.closed) {
      executeFinalizer(finalizer);
      return;
    }
    _classPrivateFieldLooseBase(this, _finalizers)[_finalizers].add(finalizer);
  }
  unsubscribe() {
    if (this.closed) {
      return;
    }
    this.closed = true;
    const errors = new Set();
    for (const finalizer of _classPrivateFieldLooseBase(this, _finalizers)[_finalizers]) {
      try {
        executeFinalizer(finalizer);
      } catch (error) {
        if (error instanceof Error) {
          errors.add(error);
        } else {
          errors.add(new Error(String(error)));
        }
      }
    }
    _classPrivateFieldLooseBase(this, _finalizers)[_finalizers].clear();
    if (errors.size > 0) {
      throw new AggregateError(Array.from(errors), 'Unsubscription error');
    }
  }
}